module.exports = __webpack_public_path__ + "static/media/launch-icon.eb75f365.png";